import { Grid } from '@material-ui/core';
import React from 'react';
import styles from './ReviewHeader.module.scss';
import CloseIcon from '@mui/icons-material/Close';
import { connect } from 'react-redux';

const ReviewHeader = ({
	companyName,
	modelName,
	lotNumber,
	agentName,
	toPrint,
	closeReviewModal,
}) => {
	return (
		<div className={styles.header}>
			<Grid container direction='row' justifyContent='space-between'>
				<Grid item>
					<div className={styles.left}>
						<div className={styles.modal_title}>Deal Review</div>
						<div className={styles.modal_home_title}>
							<div className={styles.project_title}>
								{companyName}
							</div>
							<div className={styles.model_lot_title}>
								{`${modelName} Lot ${lotNumber}`}
							</div>
						</div>
					</div>
				</Grid>
				<Grid item>
					<div className={styles.right}>
						<div className={styles.agent_name}>
							Agent: {agentName}
						</div>
						{!toPrint && (
							<div
								className={styles.close_modal}
								onClick={closeReviewModal}
							>
								<CloseIcon />
							</div>
						)}
					</div>
				</Grid>
			</Grid>
		</div>
	);
};

const mapStateToProps = (state) => ({
	companyName: state?.profile?.profileInfo?.companyName,
	modelName:
		state.agreement?.productAvailability?.modelName ||
		state.agreement?.agreementById?.productAvailability?.modelName,
	lotNumber:
		state.agreement?.productAvailability?.lotId ||
		state.agreement?.agreementById?.productAvailability?.lotId,
	agentName: state?.signIn?.displayName,
});

export default connect(mapStateToProps)(ReviewHeader);
